import { CSSProperties } from "react";
import { COLOR } from "../../../config/constraits";
import { ClaimStatusEnum } from "../types/ClaimStatusEnum";
import { TimelineStatusEnum } from "../types/enums";

export const getStatusBudgeColorStyle = (state: ClaimStatusEnum): CSSProperties => {
    switch (state) {
        case ClaimStatusEnum.Open:
            return {
                backgroundColor: COLOR.PURPLE,
                color: "#fff",
            };
        case ClaimStatusEnum.InProgress:
            return {
                backgroundColor: "orange",
                color: "#333",
                fontWeight: 400,
            };
        case ClaimStatusEnum.Closed:
            return {
                backgroundColor: COLOR.VERD,
                color: "#333",
                fontWeight: 400,
            };
        case ClaimStatusEnum.Cancelled:
            return {
                backgroundColor: "lightgrey",
                border: "1px solid orange",
            };
        default:
            return {
                backgroundColor: "lightgrey",
                color: "#fff",
                fontWeight: 600,
            };
    }
};

export const getTimelineBudgeColorStyle = (state: TimelineStatusEnum): string => {
    switch (state) {
        case TimelineStatusEnum.Out:
            return COLOR.VERMELL;
        case TimelineStatusEnum.Warning:
            return COLOR.TARONJA_DARK;
        default:
            return "";
    }
};

export const getDetailsTimelineBackgroundColor = (state: TimelineStatusEnum): string => {
    switch (state) {
        case TimelineStatusEnum.Out:
            return COLOR.VERMELL;
        case TimelineStatusEnum.Warning:
            return COLOR.TARONJA_DARK;
        case TimelineStatusEnum.On:
            return COLOR.VERD_LIGHT;
        default:
            return "";
    }
};
